<template>
  <vs-row class="member-progress-viewer-graphic w-full h-full" :class="graphicPosition">
    <vs-col :vs-w="graphicSize">
      <img :src="graphicSrc" :alt="graphicAlt" />
    </vs-col>
  </vs-row>
</template>

<script>
import {ResourceImpl} from 'hal-client';

export default {
  name: 'member-progress-viewer-graphic',
  props: {
    styleTag: Object,
    sessionResource: ResourceImpl
  },
  data () {
    return {
      graphicSrc: null,
      graphicAlt: null
    };
  },
  computed: {
    graphicSize () {
      switch (this.styleTag.size) {
      case 'xl': return '12';
      case 'lg': return '8';
      case 'sm': return '4';
      case 'xs': return '3';
      default: return '5';
      }
    },
    graphicPosition () {
      switch (this.styleTag.horizontal) {
      case 'left': return 'justify-left';
      case 'right': return 'justify-right';
      default: return 'justify-center';
      }
    }
  },
  mounted () {
    if (!this.sessionResource.$hasLink('graphic')) return;
    this.sessionResource.$request().$get('graphic', { name: this.styleTag.id || this.styleTag.content }).then(res => {
      this.graphicSrc = URL.createObjectURL(new Blob([res.content], { type: 'image/svg+xml' }));
      this.graphicAlt = res.altText;
    });
  },
  beforeDestroy () {
    if (this.graphicSrc) {
      URL.revokeObjectURL(this.graphicSrc);
      this.graphicSrc = null;
    }
  },
  methods: {
  }
};
</script>

<style lang="scss">
.member-progress-viewer-graphic {
  img {
    width: 100%;
    height: auto;
  }
}
</style>